export default __webpack_public_path__ + "static/media/trafic-gallery-5.2045f6d5.jpg";